import React, {useEffect} from 'react';
import Map from '../components/Map/Map';
import OutroAnswer from '../components/OutroAnswer/OutroAnswer';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';

const FeedbackAnswer = ({ inactivity }) => {

    // define variables
    const { locale, location } = useParams();

    // change language
    const { i18n } = useTranslation();

    // trigger tracking
    useEffect(() => {
    
        // set language
        i18n.changeLanguage(locale);

        // perform tracking
        // gtag('event', 'screen_view', {
        //     'screen_name': `answer_${locale}`
        // });

        gtag('event', 'page_view', {
            page_path: `/${locale}/answer`
        });

        // set inactivity functionality
        inactivity();

    }, []);

    // render html
    return(
        <>
            <OutroAnswer language={locale} location={location} />
            <Map type="blur" />
        </>
    );
}

export default FeedbackAnswer;